export default __webpack_public_path__ + "static/media/889.71b24acb.png";